import { Component, OnInit, Output, EventEmitter,trigger,
  state,
  style,
  animate,
  transition,
  keyframes } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PATTERNS } from "../../../../globals";
import {
  UsersService
} from "../../../../injections/users.service";


@Component({
    moduleId: module.id,
    selector: 'create-user',
    templateUrl: '../../templates/partials/create-user.html',
    animations: [
    trigger('createUser', [
            state('void', style({
                overflow: 'hidden',
                "max-height": '0'
                
            })),
            state('inactive', style({
                overflow: 'hidden',
                "max-height": '0'
                
            })),
            state('active', style({
                display: 'block',
                "max-height": '1000px',

            })),
            transition('inactive => active', animate('400ms ease-in')),
            transition('active => inactive', animate('400ms ease-out'))
        ]),
  ]
})

export class CreateComponent implements OnInit {
    public createUser : FormGroup;
    public displayname: string;
    public cifExists: boolean = false;
    public state: string = 'inactive';
    @Output() createUserEmitter = new EventEmitter();

    constructor(private _fb: FormBuilder, private usersService: UsersService) {}

    public createUserForm() {
        let object: Object = {
            cif: this.createUser.value.cif,
            trademark: this.createUser.value.comercialName,
            legal_name: this.createUser.value.legalName,
            street: this.createUser.value.street,
            number: this.createUser.value.number,
            floor: this.createUser.value.floor || '',
            door: this.createUser.value.door || '',
            postal_code: this.createUser.value.postalCode
        }
        object = JSON.stringify(object);
        this.createUserEmitter.emit(object);
    }

    public toggleMove() {
        this.state = (this.state === 'inactive' ? 'active' : 'inactive');
    }

    public setCIFStatus(status: string) {
        //console.log(status);
        if(status == "NOTOK") {
            this.cifExists = true;
            this.createUser.controls['cif'].setErrors({'incorrect': true});
        }else{
            this.cifExists = false;
        }
    }

    ngOnInit() {

        this.createUser = this._fb.group({
            cif: ['', [Validators.required]],
            comercialName: ['', [Validators.required]],
            legalName: ['', [Validators.required]],
            street: ['', [Validators.required]],
            number: ['', [Validators.required]],
            floor: ['', []],
            door: ['', []],
            postalCode: ['',[Validators.required,Validators.pattern(PATTERNS["postalCode"])]]
        });

        this.createUser.valueChanges.subscribe(data => {
             if(this.createUser.controls.cif.valid){
                this.usersService.checkIfUserExits(data.cif).subscribe((status) => {
                    //console.log(status);
                    this.setCIFStatus(status);
                });
             }
         });
     }
}


// WEBPACK FOOTER //
// ./src/app/modules/users/components/dummy/create.component.ts